import httpClient from '@/libs/http-client'

export function getNotice (data) {
  const url = `/notice/get_available`

  return httpClient.post(url, data).then(response => {
    return response.data.result
  })
}
